'use strict';

let indexJs = {
    /*初始化*/
    init() {
        this.setEvent();
        this.loadCommon();

        verification.init();
    },
    /*一般事件*/
    setEvent() {
        /*弹窗关闭&开启*/
        $(document).on('click', '.signup-btn', () => {
            $("#popup-form").show();
            verification.lockScroll(true);
        }).on('click', '#popup-close', () => {
            $("#popup-form").hide()
                .find('.err').hide()
                .siblings('input').val('');
            verification.lockScroll();
        })
    },
    /*载入公共头底部*/
    loadCommon() {
        let headUrl = '../../common/header.html';
        let footUrl = '../../common/footer.html';
        $('#header').load(headUrl);
        $('#footer').load(footUrl);
    }
}

indexJs.init();